// Selectors
import { selectedFieldIdNotValidated$ } from 'hfty-map/src/selectors/selectedFieldId'
import { subfields$ } from 'fc-assets'

// Libs
import { createSelector } from 'reselect'
import _find from 'lodash/find'

export default createSelector(
  [
    selectedFieldIdNotValidated$,
    subfields$,
  ],
  (selectedFieldId, subfields) => {
    return _find(subfields, (subfield) =>
      subfield.parent === selectedFieldId
    )
  }
)
